module.exports = __webpack_public_path__ + "static/media/mapi32_801.221f6832.ico";